// An app that runs under a path (`/compliance`) stores the addresses in rich text without it
// (`/images/file/k/n.png`) and shows them with it. The editor shows the based form and posts the
// stored form; these two functions are the two directions. The server renders the base as a Stimulus
// value (`Hosting:BaseUrl`), so nothing here reads it from the page address.

// Attributes that carry an address. TinyMCE keeps its own copy of an image's or link's address in the
// `data-mce-` pair, so the posted value is cleaned of the base in those too.
const ADDRESS_ATTRIBUTES = ["src", "href", "data-mce-src", "data-mce-href"];

// App-rooted: one leading slash. `//host/x` and `/\host/x` name another host.
function isAppRooted(address: string): boolean {
    return address.startsWith("/") && !address.startsWith("//") && !address.startsWith("/\\");
}

/** `address` with `pathBase` in front of it when it is app-rooted; any other address as it is. */
export function addPathBase(pathBase: string, address: string): string {
    return pathBase !== "" && isAppRooted(address) ? pathBase + address : address;
}

/**
 * `html` with `pathBase` taken off every address that starts with it followed by a slash. HTML that
 * holds no such address, or an empty base, comes back as the same string, not parsed and serialised.
 */
export function stripPathBase(pathBase: string, html: string): string {
    if (pathBase === "") return html;

    const prefix = `${pathBase}/`;
    const body = new DOMParser().parseFromString(html, "text/html").body;
    let changed = false;

    for (const element of body.querySelectorAll(ADDRESS_ATTRIBUTES.map((name) => `[${name}]`).join(","))) {
        for (const name of ADDRESS_ATTRIBUTES) {
            const address = element.getAttribute(name);
            if (address === null || !address.startsWith(prefix)) continue;

            element.setAttribute(name, address.slice(pathBase.length));
            changed = true;
        }
    }

    return changed ? body.innerHTML : html;
}
